import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationParticipantConsent.vue";

export const selector = (item: Notification): boolean => {
  return [NotificationType.PARTICIPANT_APPROVED, NotificationType.PARTICIPANT_REJECTED].includes(item.type);
};
